var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M25.167,2H12.433A4.839,4.839,0,0,0,7.6,6.833V7.6H6.833A4.839,4.839,0,0,0,2,12.433V25.167A4.839,4.839,0,0,0,6.833,30H19.567a4.825,4.825,0,0,0,4.769-4.2h.831A4.839,4.839,0,0,0,30,20.967V6.833A4.839,4.839,0,0,0,25.167,2ZM27.2,20.967A2.035,2.035,0,0,1,25.167,23H24.4V12.433A4.839,4.839,0,0,0,19.567,7.6H10.4V6.833A2.035,2.035,0,0,1,12.433,4.8H25.167A2.035,2.035,0,0,1,27.2,6.833Z",
    transform: "translate(-2 -2)",
    fill: "#71207c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ac7ebe3357b4e1531aa8ee39d9c8f452.svg";
export { ForwardRef as ReactComponent };